import React from 'react';
import { Chip } from '@mui/material';
import { CollectionScheduledEmail } from '../model';
import { scheduleStatusChip } from '../utils';
import { scheduledEmailTooltipProps } from './ScheduledEmailTableTooltip';

interface ScheduleStatusCellProps {
  row: CollectionScheduledEmail;
}

const ScheduleStatusCell: React.FC<ScheduleStatusCellProps> = ({ row }) => {
  const status = scheduleStatusChip(row);

  return (
    <span {...scheduledEmailTooltipProps(status.tooltip)} style={{ display: 'inline-flex' }}>
      <Chip label={status.label} color={status.color} size="small" variant="outlined" aria-label={status.tooltip} />
    </span>
  );
};

export default ScheduleStatusCell;
